var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2323 25C50.4673 25 52.6173 25.8833 54.199 27.4683C55.7823 29.05 56.6673 31.1833 56.6673 33.4167V46.5833C56.6673 51.2333 52.884 55 48.2323 55H31.7673C27.1157 55 23.334 51.2333 23.334 46.5833V33.4167C23.334 28.7667 27.099 25 31.7673 25H48.2323ZM50.884 35.9L51.0173 35.7667C51.4157 35.2833 51.4157 34.5833 50.999 34.1C50.7673 33.8517 50.449 33.7 50.1173 33.6667C49.7673 33.6483 49.434 33.7667 49.1823 34L41.6673 40C40.7007 40.8017 39.3157 40.8017 38.334 40L30.834 34C30.3157 33.6167 29.599 33.6667 29.1673 34.1167C28.7173 34.5667 28.6673 35.2833 29.049 35.7833L29.2673 36L36.8507 41.9167C37.784 42.65 38.9157 43.05 40.1007 43.05C41.2823 43.05 42.434 42.65 43.3657 41.9167L50.884 35.9Z",
    fill: "#004F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.398035ff08d979b4f4dc2bcba1f405fa.svg";
export { ForwardRef as ReactComponent };